<style lang="sass">
@import ~bi/utilities
@import ~bi/brand/variables
@import ../../assets/sass/m3_variables
@import sass/covid
</style>

<template>
    <Zone
        :id="data.id"
        :dataLabel="$json.covid.dataLabel"
        :contrast="contrast"
        class="g_covid">
        <Logo v-if="data.id === 'xbanner'" :covid="true" />
        <Heading
            :level="2"
            v-html="data.name"
            class="g_visually_hidden" />
        <Paragraph
            :content="data.keywords"
            size="XL"
            class="g_visually_hidden" />
        <ul class="g_visually_hidden">
            <li v-for="(item, i) of data.list" :key="i">
                <Paragraph
                    :content="item"
                    size="L" />
            </li>
        </ul>
        <div
            class="g_image"
            v-img-src="{ folder: 'covid', name: data.image, suffix: false }" />
        <footer>
            <Paragraph
                :content="$json.footer.adress"
                size="M" />
            <div class="g_cta">
                <Cta
                    type="text"
                    class="g_link"
                    :link="$json.footer.fixe.link"
                    target="_blank"
                    :content="$json.footer.fixe.cta" />
            </div>
            <div class="g_cta">
                <Cta
                    type="text"
                    class="g_link"
                    :link="$json.footer.mobile.link"
                    target="_blank"
                    :content="$json.footer.mobile.cta" />
            </div>
            <div class="g_cta">
                <Cta
                    type="text"
                    class="g_link"
                    :link="mailto + email"
                    target="_blank"
                    :content="email" />
            </div>
        </footer>
    </Zone>
</template>

<script>
import Logo from '../../components/Logo'

export default {
    name: 'Covid',
    components: {
        Logo
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        contrast: {
            type: String,
            default: 'light'
        }
    },
    data () {
        return {
            mailtoBase64: 'bWFpbHRvOg==',
            mailto: '',
            emailBase64: 'Y29udGFjdEBtMy1jb21tdW5pY2F0aW9uLmZy',
            email: ''
        }
    },
    mounted () {
        setTimeout(() => {
            this.mailto = atob(this.mailtoBase64)
            this.email = atob(this.emailBase64)
        }, 500)
    }
}
</script>
